<script setup>
import AnButton from "@/components/common/AnButton.vue";
import { useUserStore } from "@/store/user-store";

const props = defineProps({
  data: {
    type: Object,
    default: {},
  },
});

const store = useUserStore();
</script>

<template>
  <div class="mt-30">
    <div class="banner-container br-10 w-100 d-flex">
      <div class="d-flex flex-direction-column justify-center gap-20 p-25 w-60">
        <span class="font-25 font-weight-700">{{
          data.custGoals
            ? "You can set more goals! Go ahead!"
            : "You haven't set any goal! Please add a new goal."
        }}</span>
        <AnButton
          :label="data.custGoals ? 'Set Goal' : 'Add Goal'"
          variant="white"
          @click="
            () => {
              store.setTabView('My Goals');
              !store.goalSummary && store.loadGoalSummary();
            }
          "
          class="w-max"
        />
      </div>
      <div class="d-flex align-items-center justify-center w-40">
        <img
          src="@/assets/images/goal-banner.png"
          height="120px"
          width="286px"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.banner-container {
  background-color: var(--an-primary);
  background-image: var(--an-auth-grain);
  background-size: cover;
  color: var(--an-white);
}
</style>
